import "../styles/component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

function PlasticSurgery() {
  return (
        <>
            <section className="general-surgery hide-on-mobile">
                <img
                    src={require("../assets/img/services/big-4.png")}
                    alt="General Surgery"
                    className="top-band-img"
                />
            </section>
            <section className="general-surgery-content">
                <div className="1stblock">
                    <span className="title">What is Plastic & Reconstructive Surgery?</span>
                    <p>
                        This specialty addresses the repair and reconstruction of tissues affected by injury, disease, or surgical treatment, with attention to function and appearance.
                    </p>
                </div>
                <div className="general-surgery-row">
                    <div className="general-surgery-col general-surgery-col-1">
                        <span className="subtitle">Services Include:</span>
                        <ul className="general-surgery-list">
                            <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Reconstructive procedures
                            </li>
                            <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Cosmetic surgical procedures
                            </li>
                            <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Post-trauma and post-surgical reconstruction
                            </li>
                        </ul>
                    </div>
                    <div className="general-surgery-col general-surgery-col-2">
                        <span className="subtitle">Why This Service Matters</span>
                        <p>Reconstructive care supports physical recovery and functional restoration following injury or medical treatment.</p>
                    </div>
                </div>
            </section>
           
        </>
    )
}

export default PlasticSurgery;
